// import DashboardIcon from '@mui/icons-material/Dashboard';
import BusinessIcon from '@mui/icons-material/Business';
import GroupIcon from '@mui/icons-material/Group';
import { lang } from "../Utils/lang";
import { localUrlEnum } from "../Utils/urlEnum";

export const ROUTER_DASHBOARD = {
  routes: ["/", "/login",localUrlEnum.dashboard, localUrlEnum.companies, localUrlEnum.users, "*"],
};

export const MAIN_SLIDER_DASHBOARD = [
  {
    name: lang.companies,
    path: localUrlEnum.companies,
    icon: <BusinessIcon />,
    orderId: 0,
  },
  // {
  //   name: lang.dashboard,
  //   path: localUrlEnum.dashboard,
  //   icon: <DashboardIcon />,
  //   orderId: 1,
  // },
  {
    name: lang.users,
    path: localUrlEnum.users,
    icon: <GroupIcon />,
    orderId: 1,
  },
];
